import React, { useCallback, useRef } from "react"
import { toggleModal } from "components/Stacker/actions/ModalActions"
import ModalConfig from "components/Stacker/config/ModalConfig"
import BreakPointConfig from "components/Stacker/constants/breakpoints"
import { useDispatch } from "react-redux"
import MediaQuery from "react-responsive"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { NextArrow, PreviousArrow } from "../../Common/Arrows/Arrows"
import Video from "../../Common/IntroCarousel/IntroCarouselVideo"
import "./IntroCarousel.scss"

function IntroCarousel() {
  const dispatch = useDispatch()
  const sliderRef = useRef()
  const onNextClick = useCallback(() => {
    sliderRef.current.slickNext()
  }, [])

  const onStartStackClick = useCallback(() => {
    dispatch(toggleModal(ModalConfig.MODAL_STACKER_HELP, false))
  }, [dispatch])

  const sliderSettings = {
    cssEase: "ease-in-out",
    dots: true,
    infinite: true,
    lazyLoad: true,
    nextArrow: <NextArrow />,
    prevArrow: <PreviousArrow />,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
  }
  return (
    <div className="d-flex h-100 w-100 justify-content-between">
      <Slider ref={sliderRef} className="slider w-100" {...sliderSettings}>
        <div className="slide-container d-flex w-100 h-100">
          <div className="video-responsive">
            <Video id="678853583" h="fa5f805334" />
          </div>
          <div className="slide-copy-container">
            <div className="slide-copy text-center">
              <MediaQuery query={BreakPointConfig.IS_MOBILE}>
                <span>STEP 1 / CHOOSE YOUR CHAIN</span>
                <p>Select your style and material.</p>
              </MediaQuery>
              <MediaQuery query={BreakPointConfig.IS_DESKTOP}>
                <span>STEP 1</span>
                <h5>CHOOSE YOUR CHAIN</h5>
                <p>Select your style and material.</p>
                <button
                  className="btn btn-blackrect mt-4 w-100"
                  onClick={onNextClick}
                >
                  Next Step
                </button>
              </MediaQuery>
            </div>
          </div>
        </div>
        <div className="slide-container d-flex w-100 h-100">
          <div className="video-responsive">
            <Video id="678853596" h="2d54b3365d" />
          </div>
          <div className="slide-copy-container">
            <div className="slide-copy text-center">
              <MediaQuery query={BreakPointConfig.IS_MOBILE}>
                <span>STEP 2 / SELECT AMULETS</span>
                <p>
                  Drag and drop your favorite designs to see them on your chain.
                </p>
              </MediaQuery>
              <MediaQuery query={BreakPointConfig.IS_DESKTOP}>
                <span>STEP 2</span>
                <h5>SELECT AMULETS</h5>
                <p>
                  Drag and drop your favorite designs to see them on your chain.
                </p>
                <button
                  className="btn btn-blackrect mt-4 w-100"
                  onClick={onNextClick}
                >
                  Next Step
                </button>
              </MediaQuery>
            </div>
          </div>
        </div>
        <div className="slide-container d-flex w-100 h-100">
          <div className="video-responsive">
            <Video id="678853610" h="80a57ee02d" />
          </div>
          <div className="slide-copy-container">
            <div className="slide-copy text-center">
              <MediaQuery query={BreakPointConfig.IS_MOBILE}>
                <span>STEP 3 / REARRANGE AMULETS</span>
                <p>
                  Drag amulets to rearrange them
                  <br />
                  on your chain.
                </p>
              </MediaQuery>
              <MediaQuery query={BreakPointConfig.IS_DESKTOP}>
                <span>STEP 3</span>
                <h5>REARRANGE AMULETS</h5>
                <p>
                  Drag amulets to rearrange them
                  <br />
                  on your chain.
                </p>
                <button
                  className="btn btn-blackrect mt-4 w-100"
                  onClick={onNextClick}
                >
                  Next Step
                </button>
              </MediaQuery>
            </div>
          </div>
        </div>
        <div className="slide-container d-flex w-100 h-100">
          <div className="video-responsive">
            <Video id="678853631" h="4bfcfb02e3" />
          </div>
          <div className="slide-copy-container">
            <div className="slide-copy text-center">
              <MediaQuery query={BreakPointConfig.IS_MOBILE}>
                <span>STEP 4 / REMOVE AMULETS</span>
                <p>Tap or click &apos;x&apos; to remove an amulet.</p>
              </MediaQuery>
              <MediaQuery query={BreakPointConfig.IS_DESKTOP}>
                <span>STEP 4</span>
                <h5>REMOVE AMULETS</h5>
                <p>Tap or click &apos;x&apos; to remove an amulet.</p>
                <button
                  className="btn btn-blackrect mt-4 w-100"
                  onClick={onNextClick}
                >
                  Next Step
                </button>
              </MediaQuery>
            </div>
          </div>
        </div>
        <div className="slide-container d-flex w-100 h-100">
          <div className="video-responsive">
            <Video id="678854133" h="4b8b126f14" />
          </div>
          <div className="slide-copy-container">
            <div className="slide-copy text-center">
              <MediaQuery query={BreakPointConfig.IS_MOBILE}>
                <span>
                  STEP 5 / TAP &#34;NEXT STEP&#34;
                  <br />
                  WHEN YOU ARE DONE
                </span>
                <p>Tap or click Review Your Selection.</p>
              </MediaQuery>
              <MediaQuery query={BreakPointConfig.IS_DESKTOP}>
                <span>STEP 5</span>
                <h5>
                  TAP &#34;NEXT STEP&#34;
                  <br />
                  WHEN YOU ARE DONE
                </h5>
                <p>Tap or click Review Your Selection.</p>
                <button
                  className="btn btn-blackrect mt-4 w-100"
                  onClick={onStartStackClick}
                >
                  Start Now
                </button>
              </MediaQuery>
            </div>
          </div>
        </div>
      </Slider>
    </div>
  )
}

export default IntroCarousel
